import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/solver-configuration");

export const Route = createFileRoute("/solver-configuration")({
  head: () => ({
    meta: [
      { title: "Solver configuration — LevelLoad" },
      { name: "description", content: "Solver configuration — LevelLoad transport planning." },
      { property: "og:title", content: "Solver configuration — LevelLoad" },
      {
        property: "og:description",
        content: "Solver configuration — LevelLoad transport planning.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
